<template>
  <v-app class="bg-white">
    <!-- Header with AutoSync Logo -->
    <v-app-bar
      elevation="0"
      color="transparent"
      absolute
      class="sweepstakes-header"
    >
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="auto" class="text-center">
            <router-link to="/sweepstakes" class="text-decoration-none">
              <img
                src="@/assets/img/logo.png"
                alt="AutoSync Logo"
                class="autosync-logo"
                :height="$vuetify.breakpoint.xs ? 60 : 80"
              />
            </router-link>
            <div class="mt-2">
              <v-chip
                color="orange"
                text-color="white"
                class="header-badge"
                small
              >
                <v-icon left small>mdi-file-document</v-icon>
                TERMS & CONDITIONS
              </v-chip>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <div class="terms-container">
        <v-container class="py-16">
          <v-row justify="center">
            <v-col cols="12" lg="10" xl="8">
              <!-- Back Button -->
              <div class="mb-6">
                <v-btn
                  color="orange"
                  outlined
                  @click="$router.go(-1)"
                  class="mb-4"
                >
                  <v-icon left>mdi-arrow-left</v-icon>
                  Back to Sweepstakes
                </v-btn>
              </div>

              <!-- Terms Content -->
              <v-card class="terms-card elevation-8">
                <v-card-title class="terms-header">
                  <h1 class="white--text text-center w-100">
                    AutoSyncX™ Sweepstakes Terms & Conditions
                  </h1>
                </v-card-title>

                <v-card-text class="pa-8">
                  <!-- No Purchase Notice -->
                  <div class="no-purchase-notice mb-6">
                    <h2 class="orange--text text-center mb-3">
                      NO PURCHASE NECESSARY TO ENTER OR WIN
                    </h2>
                    <p class="text-center font-weight-bold">
                      A PURCHASE DOES NOT INCREASE YOUR CHANCES OF WINNING.
                    </p>
                  </div>

                  <!-- Terms Sections -->
                  <div class="terms-content">
                    <div class="term-section mb-6">
                      <h3 class="section-title">1. Eligibility</h3>
                      <p class="section-text">
                        Open to legal residents of the 50 United States and the District of Columbia who are 18 years of age or older at the time of entry. Employees, officers, and directors of AutoSyncX™ ("Sponsor"), its affiliates, subsidiaries, advertising and promotion agencies, and immediate family members (spouse, parents, siblings, and children) or persons living in the same household are not eligible.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">2. Sweepstakes Period</h3>
                      <p class="section-text">
                        Each individual AutoSyncX™ sweepstakes will have its own designated start and end date. The specific sweepstakes period will be clearly stated on the promotional page and related materials.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">3. How to Enter</h3>
                      
                      <div class="subsection mb-4">
                        <h4 class="subsection-title">Purchase Entry:</h4>
                        <p class="section-text">
                          Each dollar donated or spent through the AutoSyncX™ sweepstakes platform may grant a specific number of entries based on the rules of that specific promotion.
                        </p>
                      </div>

                      <div class="subsection mb-4">
                        <h4 class="subsection-title">Bonus Entries:</h4>
                        <p class="section-text">
                          Participants may be eligible to earn bonus entries by completing actions such as:
                        </p>
                        <ul class="bonus-list">
                          <li>Following AutoSyncX™ on social media platforms</li>
                          <li>Sharing sweepstakes promotions</li>
                          <li>Referring friends using unique referral links</li>
                        </ul>
                        <p class="section-text">
                          Details of each bonus entry method will be provided per campaign.
                        </p>
                      </div>

                      <div class="subsection mb-4">
                        <h4 class="subsection-title">Mail-In Entry (No Purchase Necessary):</h4>
                        <p class="section-text">
                          To enter without making a purchase, handwrite your name, complete address, phone number, and email address on a 3" x 5" card and mail it in a standard envelope to:
                        </p>
                        <div class="mail-address">
                          <p class="font-weight-bold">
                            AutoSyncX Sweepstakes Entry<br>
                            2 N Central Ave, FL 19 Unit 1931<br>
                            Phoenix, AZ 85004
                          </p>
                        </div>
                        <p class="section-text">
                          Each mail-in entry will receive the equivalent number of entries as outlined in the individual sweepstakes offer. Limit one entry per envelope. Mail-in entries must be received by the final date of the specific promotion.
                        </p>
                      </div>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">4. Prize</h3>
                      <p class="section-text">
                        Prize descriptions, values, and the number of winners will vary by sweepstakes and will be clearly outlined in the associated promotional material. No substitution or transfer of prize permitted except at Sponsor's sole discretion.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">5. Winner Selection & Notification</h3>
                      <p class="section-text">
                        Winners will be selected in a random drawing from all eligible entries received during the applicable sweepstakes period. Drawings will be conducted by Sponsor or its authorized designee. Winners will be notified by email and must respond within 48 hours to claim the prize or an alternate winner may be selected.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">6. Odds of Winning</h3>
                      <p class="section-text">
                        Odds of winning depend on the number of eligible entries received during the applicable sweepstakes period.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">7. Taxes</h3>
                      <p class="section-text">
                        All federal, state, and local taxes on prizes are the sole responsibility of the winner.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">8. Publicity</h3>
                      <p class="section-text">
                        By accepting a prize, winner grants Sponsor permission to use their name, likeness, city, and state of residence for promotional purposes in any media without additional compensation, unless prohibited by law.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">9. Limitation of Liability</h3>
                      <p class="section-text">
                        Sponsor is not responsible for lost, late, incomplete, stolen, misdirected, or illegible entries. Sponsor reserves the right to cancel, modify, or suspend any sweepstakes if fraud or technical failures compromise the integrity of the promotion.
                      </p>
                    </div>

                    <div class="term-section mb-6">
                      <h3 class="section-title">10. Governing Law</h3>
                      <p class="section-text">
                        This promotion is governed by the laws of the State of Arizona. All claims arising out of or relating to any AutoSyncX™ sweepstakes must be resolved in the state or federal courts located in Maricopa County, Arizona.
                      </p>
                    </div>

                    <div class="term-section">
                      <h3 class="section-title">11. Sponsor</h3>
                      <div class="sponsor-info">
                        <p class="font-weight-bold text-center">
                          AutoSyncX™ / Affiliate Car LLC<br>
                          2 N Central Ave, FL 19 Unit 1931<br>
                          Phoenix, AZ 85004
                        </p>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'SweepstakesTerms',
  data() {
    return {}
  },
  mounted() {
    // Scroll to top when component loads
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
/* Header Styles */
.sweepstakes-header {
  z-index: 1000 !important;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.1) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  height: 120px !important;
  padding: 1rem 0;
}

.autosync-logo {
  transition: transform 0.3s ease;
  filter: brightness(1.2) contrast(1.1);
}

.autosync-logo:hover {
  transform: scale(1.05);
}

.header-badge {
  animation: glow-pulse 2s ease-in-out infinite alternate;
}

@keyframes glow-pulse {
  from { 
    box-shadow: 0 0 5px rgba(255, 107, 53, 0.5);
  }
  to { 
    box-shadow: 0 0 20px rgba(255, 107, 53, 0.8), 0 0 30px rgba(255, 107, 53, 0.4);
  }
}

/* Terms Container */
.terms-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding-top: 120px;
}

.terms-card {
  border-radius: 20px;
  overflow: hidden;
}

.terms-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 2rem;
}

/* Content Styles */
.no-purchase-notice {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border-radius: 15px;
  padding: 2rem;
  border: 2px solid #ff6b35;
}

.terms-content {
  line-height: 1.8;
}

.term-section {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1.5rem;
}

.term-section:last-child {
  border-bottom: none;
}

.section-title {
  color: #1a1a2e;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.subsection-title {
  color: #ff6b35;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.section-text {
  color: #333;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.bonus-list {
  margin: 1rem 0;
  padding-left: 2rem;
}

.bonus-list li {
  margin-bottom: 0.5rem;
  color: #333;
}

.mail-address {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 1rem;
  margin: 1rem 0;
  text-align: center;
}

.sponsor-info {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 10px;
  padding: 1.5rem;
  margin: 1rem 0;
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sweepstakes-header {
    height: 100px !important;
    padding: 0.5rem 0;
  }
  
  .terms-container {
    padding-top: 100px;
  }
  
  .terms-header {
    padding: 1.5rem;
  }
  
  .no-purchase-notice {
    padding: 1.5rem;
  }
  
  .section-title {
    font-size: 1.2rem;
  }
  
  .subsection-title {
    font-size: 1rem;
  }
}
</style>
